import type { BatchStats } from '@/hooks/useBatchUpload';
import React from 'react';

export interface OverallProgressBarProps {
  stats: BatchStats;
  isActive: boolean;
}

const OverallProgressBar: React.FC<OverallProgressBarProps> = ({ stats, isActive }) => {
  if (!isActive) return null;

  return (
    <div className="px-3 py-2 border-b border-white/[0.04]">
      <div className="flex items-center gap-2">
        <div className="flex-1 h-1.5 bg-white/10 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-brand-500 to-accent-500 rounded-full transition-all duration-500"
            style={{ width: `${stats.overallProgress}%` }}
          />
        </div>
        <span className="text-[10px] text-gray-400 w-8 text-right">
          {stats.overallProgress}%
        </span>
      </div>
    </div>
  );
};

export default OverallProgressBar;
